import React, { Component } from 'react';
import { Row, Col, Card, Button, Popconfirm, Spin, PageHeader, Layout, message, Breadcrumb, List, Typography, Space } from 'antd';
import axios from 'axios';
import { Link, useParams, useNavigate } from 'react-router-dom';
import Logged from '../../../Hooks/Logged';
import usePermissions from '../../../Hooks/usePermissions';
import { IconArrowBack, IconDelete, IconEdit } from '../../Widgets/Iconos';
import FloatingButton from '../../Widgets/Floating Button/FloatingButton';
import ModalSubproyectos from './ModalSubproyectos';
import CustomAvatar from '../../Widgets/Avatar/Avatar'

const { Content } = Layout;
const { Text } = Typography;

class Subproyectos extends Component {

  constructor(props) {
      super(props)
      this.state = {
        loading: false,
        modal_visible: false,
        subproyecto_id: undefined,
        subproyectos: {
          data: [], 
          page: 1, 
          limit: 20, 
          total: 0, 
          pages: 0
        },
      }
  }
  
  componentDidMount() {
    console.log(this.props)
    axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token');
    this.getProyecto();
    this.getSubproyectos();
  }


  componentDidUpdate(prevProps) {
    if (this.props.params.proyecto_id !== prevProps.params.proyecto_id || this.props.search !== prevProps.search) {
      this.getSubproyectos({ page: 1 })
    }
  }

  getProyecto = async () => {
    const { proyecto_id } = this.props.params;
    this.setState({ loading: true })

    try {

      const { data: proyecto } = await axios.get(`/proyectos/${proyecto_id}`);
      this.setState({ proyecto })

    } catch (err) {

      console.error(err);
      message.error('Error al traer el proyecto');

    } finally {

      this.setState({ loading: false })

    }
  }

  getSubproyectos = async ({
    page = this.state.subproyectos.page,
    limit = this.state.subproyectos.limit
  } = {}) => {

    const { proyecto_id } = this.props.params
    const { search }      = this.props

    this.setState({ loading: true })

    try {

      const { data } = await axios.get('/subproyectos', {
        params: { proyecto_id, page, limit, search }
      })
      this.setState({ subproyectos: data })

    } catch (err) {

      console.error(err)
      message.error('Error al traer subproyectos')

    } finally {

      this.setState({ loading: false })

    }
  }

  render() {

    return (
      <>
        <Spin spinning={false}>
          <PageHeader
            className="site-page-header custom-page-header"
            backIcon={<IconArrowBack/>}
            onBack={() => this.props.navigate(-1)}
            title={(this.state.proyecto) ?
              (
                  <Breadcrumb separator="de" className='breadcrumb-header'>
                      <Breadcrumb.Item >SubProyectos</Breadcrumb.Item>
                      <Breadcrumb.Item >
                          <Link title="Ir a proyectos" to={`/admin/proyectos`}>
                              {this.state.proyecto.nombre}
                          </Link>
                      </Breadcrumb.Item>
                  </Breadcrumb>
              )
              : "SubProyectos"
            }
          />

          <Content className="admin-content content-bg pd-1">
            <List 
              loading={this.state.loading}
              className="component-list"
              itemLayout="horizontal"
              locale={{ emptyText: "Sin SubProyectos " }}
              dataSource={this.state.subproyectos.data}
              pagination={{
                  current: this.state.subproyectos.page,
                  pageSize: this.state.subproyectos.limit,
                  total: this.state.subproyectos.total,
                  showSizeChanger: true,
                  position: 'bottom',
                  className: "flex-left",
                  onChange: (page, limit) => {
                      console.log("page", page, limit);
                      this.getSubproyectos({ page, limit })
                  }
              }}

              header={<Row className="header-list width-100 pr-1 pl-1" gutter={[16, 16]} >
              
                  <Col xs={24} lg={10}  className="center">
                      <Text strong>Nombre</Text>
                  </Col>
                  <Col xs={24} lg={10} className="center">
                      <Text strong>Descripción</Text>
                  </Col>
                  <Col xs={24} lg={4} className="center">
                      <Text strong>Acciones</Text>
                  </Col>
              </Row>}

              renderItem={item => (
                  <List.Item className="component-list-item">
                      <Card className="card-list">
                          <Row className="width-100 " gutter={[16, 16]}>

                              <Col xs={24} lg={10} className="center" style={{ display: 'flex', alignItems: 'center' }}>
                                <CustomAvatar
                                  size={42}
                                  placeholder={true}
                                  url={ item.logo ? {
                                    url: axios.defaults.baseURL + "/subproyectos/logo/" + item._id,
                                    logo: item.logo.file,
                                    name: item.nombre
                                  } : null}
                                  name={item.nombre}
                                />
                                <Text ellipsis style={{ marginLeft: 8 }}>{item.nombre}</Text>
                              </Col>



                              <Col xs={24} lg={10}  className="center">
                                  <Text>{item.descripcion}</Text>
                              </Col>
                              <Col xs={24} lg={4} className="center">
                                  <Space size="small" direction="horizontal">
                                      <Button
                                          type="primary"
                                          disabled = {!this.props.editSubproyectos}
                                          icon={<IconEdit />}
                                          title="Editar"
                                          onClick={() => { this.setState({ modal_visible: true, subproyecto_id: item._id }) }}
                                      />
                                      <Popconfirm
                                          placement="topRight"
                                          title="¿Deseas eliminar este subproyecto?"
                                          
                                          onConfirm={() => axios.delete('/subproyectos',
                                              { params: {id: item._id} }).then(() => {
                                                  this.getSubproyectos()
                                                  message.success('SubProyecto eliminado')
                                              }).catch(error => console.log(error))}
                                          okText="Si"
                                          cancelText="No"
                                      >
                                          <Button
                                              type="primary"
                                              disabled = {!this.props.deleteSubproyectos}
                                              icon={<IconDelete />}
                                              title="Eliminar"
                                              danger
                                          />
                                      </Popconfirm>
                                  </Space>
                              </Col>
                          </Row>
                      </Card>
                  </List.Item>
              )}
            />
          </Content>

          {this.props.createSubproyectos ? <FloatingButton title="Nuevo registro" onClick={() => this.setState({ modal_visible: true })} /> : null}

          <ModalSubproyectos
              open={this.state.modal_visible}
              onClose={() => {
                  this.setState({ modal_visible: false, subproyecto_id: undefined })
                  this.getSubproyectos()
              }}
              subproyecto_id={this.state.subproyecto_id}
              proyecto_id={this.props.params.proyecto_id}
          />
        </Spin>
      </>
    )
  }
}

export default function(props) {
  const params = useParams();
  const navigate = useNavigate();
  const user = React.useContext(Logged);
  const permissions = usePermissions(user?.rol_id?.permisos, {
    createSubproyectos: ['proyectos','create'],
    editSubproyectos:   ['proyectos','edit'],
    deleteSubproyectos: ['proyectos','delete'],
  });

  return (
    <Subproyectos {...props} {...permissions} params={params} navigate={navigate} />
  );
}